import React = require('react');
import { useState } from 'react';

export const GadgetMoreInfo = ({ deprecation }) => {
  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const changeShowMoreInfo = () => {
    setShowMoreInfo(!showMoreInfo)
  }

  return (
      <>
        <div className="margin-bottom">This optional cover provides peace of mind in case they’re lost, stolen or damaged during your trip.</div>
        <div className="bold margin-bottom">What's covered:</div>
        <ul className="margin-bottom" style={{marginLeft: '15px'}}>
          <li>Gadget Cover protects up to £1,500 per trip for loss, theft or damage</li>
          <li>The maximum we will pay per item is £1500</li>
          <li>You’re covered for gadgets owned by you or any named traveller</li>
        </ul>
        <div className="margin-bottom">
          <span className="more-info" onClick={changeShowMoreInfo}>
            {showMoreInfo ? ' Less information' : ' More information'}
          </span>
        </div>
        {showMoreInfo && (
          <>
            <div className="bold margin-bottom">What's not covered:</div>
            <ul style={{marginLeft: '15px', marginBottom: '15px'}}>
              <li>Gadgets left unattended or in checked in luggage</li>
              <li>General wear and tear</li>
              <li>Mechanical Faults</li>
            </ul>
            <div>
              For further information please click <a className="pointer" href={'https://www.admiral.com/travel-insurance/gadget-insurance.php'} target={'_blank'}>here</a>
            </div>
          </>
        )}
      </>
  );
};
